<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat color="transparent">
        <v-card-text class="py-0">
          <v-row align="center" style="height: 58px;">
            <v-col cols="4" class="pb-0" align="center">
              <v-btn depressed small :outlined="!tempUser.chatFilter" :color="tempUser.chatFilter ? 'primary' : 'success' " @click="onChangeChatFilter()">{{ tempUser.chatFilter ? '全ユーザ表示' : '登録ユーザのみ表示' }}</v-btn>
            </v-col>
            <v-col cols="4" class="pb-0 pl-0">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="全文検索"
                clearable
                hide-details
                outlined
                dense
                @click:append="onSearch()"
                @keyup.enter="onSearch()"
                @click:clear="onSearchClear()"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
              <template v-if="item">
                <v-row align="center" class="b-B" style="height:46px;">
                  <v-col cols="auto" class="pa-0">
                    <v-avatar size="34">
                      <img v-if="item.avatar" :src="item.avatar.thumbnail">
                      <v-avatar v-else size="32" :color="item.color ? item.color : 'primary'"><span class="font-weight-bold white--text" style="font-size:23px; user-select: none;">{{ getNamePrefixFromItem(item) }}</span></v-avatar>
                    </v-avatar>
                  </v-col>
                  <v-col cols="auto" class="pa-0">
                    <v-icon v-if="!item.public" color="error" small>mdi-lock</v-icon>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-row class="pl-4">
                      <v-col cols="12" class="pa-0">
                        <p class="ma-0 pa-0">{{ item.name }}</p>
                      </v-col>
                      <v-col cols="12" class="pa-0">
                        <v-chip v-if="item.chatType !== 'school'" x-small outlined color="primary">
                          <span class="hidden-sm-and-down text-overflow-hidden">{{ getSchool(item) }}</span>
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col v-if="parameter && parameter.type != 'user'" cols="auto" class="hidden-sm-and-down ">
                    <v-tooltip bottom color="transparent">
                      <template v-slot:activator="{ on }">
                        <v-row v-on="on" row align-center>
                          <v-chip color="primary" text-color="white" small depressed>
                            <v-icon small left>mdi-account-circle</v-icon>
                            <span>{{ getMember(item) + '人' }}</span>
                          </v-chip>
                        </v-row>
                      </template>
                      <v-card width="auto" color="transparent">
                        <v-card-text class="caption pa-0">
                          <v-list>
                            <v-list-item
                              v-for="(u, index) in getMemberList(item)"
                              dense
                              :key="index"
                            >
                              <v-chip color="primary" small>{{ u }}</v-chip>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-tooltip>
                  </v-col>
                  <v-btn v-if="checkPrivilege()" icon color="transparent" class="elevation-0" @click="chatsMemberDialog = true">
                    <v-icon color="primary">mdi-settings</v-icon>
                  </v-btn>
                </v-row>
              </template>
            </v-col>
          </v-row>
          <v-row align="start">
            <v-col cols="4" class="pa-0">
              <v-sheet class="overflow-y-auto" :style="contentsHeight">
                <v-col cols="12" class="pa-0">
                  <template v-if="searchDialog">
                    <template-chat-member
                      :mode="'search'"
                      :items="filteredItems"
                      :selected="item"
                      :type="'school'"
                      :share="'no'"
                      :unReadGroup="unReadGroup"
                      :unReadUser="unReadUser"
                      :filteredCounts="filteredCounts"
                      :contentsHeight="contentsHeight"
                      @select="onSelect"
                    >
                    </template-chat-member>
                  </template>
                  <template v-else>
                    <template-chat-member
                      :items="chatsItems"
                      :selected="item"
                      :type="'school'"
                      :share="'no'"
                      :unReadGroup="unReadGroup"
                      :unReadUser="unReadUser"
                      :contentsHeight="contentsHeight"
                      @select="onSelect"
                      @request="onRequest"
                    >
                    </template-chat-member>
                  </template>
                </v-col>
              </v-sheet>
            </v-col>
            <v-col class="pa-0" align="start" justify="start">
              <template v-if="searchDialog">
                <template-chat-view
                  :mode="'search'"
                  :item="item"
                  :contentsHeight="contentsHeight"
                  :messages="displayMessages"
                  :search="search"
                  @open="onOpenItem"
                  @openImage="onOpenImage"
                  @remove="onRemoveDialog"
                >
                </template-chat-view>
              </template>
              <template v-else>
                <template-chat-view
                  v-if="parameter && getStatus(item) == 'accepting'"
                  :item="item"
                  :contentsHeight="chatsContentsHeight"
                  :messages="messages"
                  @open="onOpenItem"
                  @openImage="onOpenImage"
                  @remove="onRemoveDialog"
                  @edit="onEdit"
                >
                </template-chat-view>
              </template>

              <v-card v-if="!searchDialog && parameter && parameter.status == 'accepting'" flat :color="edit ? 'green lighten-5' : 'transparent'" class="mr-3">
                <v-row class="ma-0" align="center" justify="center">
                  <v-col cols="12" class="py-0">
                    <v-row align="center" class="ma-0">
                      <v-col cols="10" class="py-0">
                        <v-row align="center" justify="start" style="height:40px;">
                          <v-col cols="1" class="pa-0">
                            <v-chip color="primary" text-color="white" x-small>宛先</v-chip>
                          </v-col>
                          <v-col cols="7" class="pa-0">
                            <v-row align="center" class="ma-0">
                              <v-avatar color="grey lighten-3" size="34">
                                <img v-if="item.avatar" :src="item.avatar.thumbnail">
                                <v-avatar v-else size="32" :color="item.color ? item.color : 'primary'"><span class="font-weight-bold white--text" style="font-size:23px; user-select: none;">{{ getNamePrefixFromItem(item) }}</span></v-avatar>
                              </v-avatar>
                              <v-icon v-if="!item.public" color="error" small>mdi-lock</v-icon>
                              <v-row>
                                <v-col cols="12" class="py-0">
                                  <p class="pl-2 ma-0 py-0 subheading">{{ item.name }}</p>
                                </v-col>
                                <v-col v-if="parameter && parameter.type != 'school'" cols="12" class="pl-5 py-0">
                                  <v-chip v-if="item.chatType !== 'school'" x-small outlined color="primary">
                                    <span class="hidden-sm-and-down text-overflow-hidden">{{ getSchool(item) }}</span>
                                  </v-chip>
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-avatar-selector
                            v-if="(!checkShareItem() && !emoji && !scheduleItem && !studentItem) || url"
                            v-model="file"
                            :previewSize="80"
                            :tile="true"
                            :enable="!checkShareItem() && emoji == null"
                            :icon="'mdi-image-plus'"
                            :noPreview="true"
                            :iconSize="28"
                            >
                          </v-avatar-selector>
                          <v-btn v-if="!file && !url && !checkShareItem() && !scheduleItem && !studentItem" icon medium @click.stop="emojiType = 'dialog', emojiDialog = true" class="pa-0 ma-0">
                            <v-icon color="primary">mdi-emoticon-outline</v-icon>
                          </v-btn>
                          <v-btn v-if="!file && !url && !emoji && !scheduleItem && !studentItem" icon medium @click.stop='onShareDialog()' class="pa-0 ma-0">
                            <v-icon color="primary">mdi-share-variant</v-icon>
                          </v-btn>
                          <v-btn v-if="checkPrivileges('plan') && !file && !url && !checkShareItem() && !emoji && !studentItem" icon medium @click.stop='scheduleDialog = true' class="pa-0 ma-0">
                            <v-icon color="primary">work</v-icon>
                          </v-btn>
                          <v-btn v-if="!file && !url && !checkShareItem() && !emoji && !scheduleItem" icon medium @click.stop='studentDialog = true' class="pa-0 ma-0">
                            <v-icon color="primary">mdi-school</v-icon>
                          </v-btn>
                        </v-row>
                        <v-row align="center">
                          <v-col cols="1" class="pa-0">
                            <v-chip :color="myMembers.length > 0 ? 'warning' : 'gray'" text-color="white" x-small>親展</v-chip>
                          </v-col>
                          <v-col cols="11" class="pa-0">
                            <v-select
                              v-model="members"
                              :items="myMembers"
                              multiple
                              dense
                              hide-details
                              item-text="name"
                              item-value="key"
                              :disabled="myMembers.length == 0"
                            >
                              <template v-slot:selection="{ item }">
                                <v-chip x-small outlined color="primary">
                                  <span>{{ item.name }}</span>
                                </v-chip>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="10" class="py-0">
                        <v-row align="center" justify="center">
                          <v-col v-if="emoji" cols="2" class="pa-0 pb-10" align="center">
                            <v-avatar tile size="64">
                              <span class="display-3">{{ emoji }}</span>
                            </v-avatar>
                          </v-col>
                          <v-col v-if="file || url" cols="2" class="pt-0 pb-6 pl-0" align="center">
                            <template v-if="file">
                              <image-preview
                                v-model="file"
                                :previewSize="70"
                                :tile="true"
                              >
                              </image-preview>
                            </template>
                            <template v-else>
                              <image-preview
                                :url="url"
                                :previewSize="70"
                                :tile="true"
                              >
                              </image-preview>
                            </template>
                          </v-col>
                          <v-col :cols="emoji || file || url ? 10 : 12" class="px-0 pb-0" align="center">
                            <v-textarea
                              solo
                              append-icon="mdi-emoticon"
                              name="input"
                              v-model="message"
                              clearable
                              no-resize
                              rows="4"
                              cols="70"
                              counter="1000"
                              :placeholder="(emoji || file) ? '補足' : '伝言'"
                              @click:append="emojiType = 'inline', emojiDialog = true"
                              :maxlength="1000"
                            ></v-textarea>
                            <v-row align="center" justify="start" class="ma-0 px-4">
                              <v-chip v-if="scheduleItem" :style="getTaskColor(scheduleItem)" x-small style="position: absolute; z-index: 1; bottom: 10px;">
                                <v-icon class='pr-2' :color="scheduleItem.type == 'event' ? 'white' : ''" small>{{ scheduleItem.type == 'event' ? 'mdi-calendar-star' : 'mdi-calendar-check' }}</v-icon>
                                <span class="pr-2" :class="scheduleItem.type == 'event' ? 'white--text' : ''">{{ scheduleItem.title + '（' + scheduleItem.startDate + '）' }}</span>
                              </v-chip>
                              <v-chip v-else-if="studentItem" color="primary" x-small style="position: absolute; z-index: 1; bottom: 10px;">
                                <v-icon class='pr-2' color="white" small>mdi-school</v-icon>
                                <span class="pr-2 white--text">{{ (studentItem.name != null ? studentItem.name : studentItem.sei) + '（' + getGradeName(getGrade(studentItem)) + '）' }}</span>
                              </v-chip>
                              <v-chip v-else-if="checkShareItem()" :color="shareItem.selected == 1 ? 'deep-orange darken-4' : 'success'" x-small style="position: absolute; z-index: 1; bottom: 10px;">
                                <v-icon class='pr-2' color="white" small>{{ getMimeType() }}</v-icon>
                                <span class="pr-2 white--text">{{ shareItem.item.name }}</span>
                              </v-chip>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="2" class="pa-0" align="center">
                        <v-row align="center" justify="center">
                          <v-col cols="12" align="center" class="pa-0">
                            <v-btn small rounded depressed :color="edit ? 'success' : 'primary'" :disabled="!checkIfSend()" @click.stop='send'>
                              <span>{{ edit ? '変更' : '送信' }}</span>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" align="center" class="pa-0 py-1">
                            <v-btn small rounded depressed color="error" :disabled="!checkIfCancel()" @click.stop='onClear()'>
                              <span>{{ '中止' }}</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>

              <v-card v-else flat color="transparent">
                <v-card-text class="pa-0">
                  <v-alert
                    v-if="item && getStatus(item) == 'none'"
                    :value="true"
                    type="warning"
                    outlined
                    dense
                  >
                    <span>伝言へアクセスできません。</span><v-btn x-small rounded depressed color="success">登録</v-btn> を押下して登録（要望）してください
                  </v-alert>
                  <v-alert
                    v-else-if="item && getStatus(item) == 'pending'"
                    :value="true"
                    type="info"
                    outlined
                    dense
                  >
                    <span>承認待ちです</span>
                  </v-alert>
                  <v-alert
                    v-else-if="item && getStatus(item) == 'requesting'"
                    :value="true"
                    type="info"
                    outlined
                    dense
                  >
                    <span>閲覧するには承認してください</span>
                  </v-alert>
                </v-card-text>
              </v-card>
             </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <div class="text-center">
      <v-dialog
        v-model="dialog"
        hide-overlay
        :max-width="'800px'"
      >
        <app-emoji
          v-if="dialog"
          @dismissed="onDismissed"
          @click='notice'
          :toolbar="true"
          :dialog='dialog'>
        </app-emoji>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog
        v-model="emojiDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
      >
        <v-card flat>
          <v-row class="ma-0" align="start">
            <v-col cols="12" class="pa-0">
              <v-toolbar dark flat height="60" color="primary">
                <v-btn fab x-small color="white" depressed @click="emojiDialog = false">
                  <v-icon class="primary--text">close</v-icon>
                </v-btn>
                <v-toolbar-title class="hidden-xs-only white--text pl-2">絵文字</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <app-emoji
                v-if="emojiDialog"
                @dismissed="onDismissed"
                @click='onEmoji'
                :dialog='emojiDialog'>
              </app-emoji>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </div>

    <div v-if="requestDialog">
      <v-dialog
        v-model="requestDialog"
        persistent
        max-width="360">
        <v-card>
          <v-card-title :class="status == 'none' ? 'title success white--text' : 'title error white--text'">{{ title }}</v-card-title>
          <v-card-text class="py-2 px-4">{{ requestMessage }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded depressed @click.native="requestDialog = false">取消</v-btn>
            <v-btn :color="status == 'none' ? 'success' : 'error'" rounded depressed @click.native="follow(item, id)">実行</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div>
      <v-dialog
        v-model="shareDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
      >
        <v-card v-if="shareDialog" flat>
          <v-row class="ma-0" align="start">
            <v-col cols="12" class="pa-0">
              <v-toolbar dark flat height="60" color="primary">
                <v-btn fab x-small color="white" depressed @click="shareItem == null, shareDialog = false">
                  <v-icon class="primary--text">close</v-icon>
                </v-btn>
                <v-toolbar-title class="hidden-xs-only white--text pl-2">共有</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-chip v-if="type == 'dialog' && checkShareItem()" small class="mr-2" color="white" outlined>{{ getShareItemName() }}</v-chip>
                <v-btn v-if="type == 'dialog'" :disabled="!checkShareItem()" rounded depressed color="white" @click="shareDialog = false">
                  <span class="primary--text font-weight-bold">選択</span>
                </v-btn>
              </v-toolbar>
              <app-google-drive
                v-if="shareDialog"
                @dismissed="onDismissed"
                :dialog='shareDialog'
                @change="onChangeItem"
                :type="type"
                :openItem="openItem"
              >
              </app-google-drive>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </div>

    <div>
      <v-dialog
        v-model="scheduleDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
      >
        <v-card flat>
          <v-row class="ma-0" align="start">
            <v-col cols="12" class="pa-0">
              <v-toolbar dark flat height="60" color="primary">
                <v-btn fab x-small color="white" depressed @click="scheduleItem == null, scheduleDialog = false">
                  <v-icon class="primary--text">close</v-icon>
                </v-btn>
                <v-toolbar-title class="hidden-xs-only white--text pl-2">共有</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="type == 'dialog'" :disabled="scheduleItem == null" rounded depressed color="white" @click="scheduleDialog = false">
                  <span class="primary--text font-weight-bold">選択</span>
                </v-btn>
              </v-toolbar>
              <schedule-main
                :type="'dialog'"
                @change="onChangeItem"
              >
              </schedule-main>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </div>

    <div>
      <v-dialog
        v-model="studentDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
      >
        <v-card flat>
          <v-row class="ma-0" align="start">
            <v-col cols="12" class="pa-0">
              <v-toolbar dark flat height="60" color="primary">
                <v-btn fab x-small color="white" depressed @click="studentItem == null, studentDialog = false">
                  <v-icon class="primary--text">close</v-icon>
                </v-btn>
                <v-toolbar-title class="hidden-xs-only white--text pl-2">共有</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="type == 'dialog'" :disabled="studentItem == null" rounded depressed color="white" @click="studentDialog = false">
                  <span class="primary--text font-weight-bold">選択</span>
                </v-btn>
              </v-toolbar>
              <app-student
                :type="'dialog'"
                @change="onChangeItem"
              >
              </app-student>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div v-if="imageDialog" class="text-center">
      <v-layout row justify-center align-center>
        <v-dialog
          v-model='imageDialog'
          max-width="512"
          >
            <v-row align="center" justify="center" class="ma-0">
              <img :src="imageUrl" width="512" style="height: auto; margin: 0 auto;" />
            </v-row>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title="削除"
        message="削除したメッセージはもとにもどせません、よろしいですか?"
        :dialog='removeDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div v-if="youtubeDialog" class="text-center">
      <v-layout row justify-center align-center>
        <v-dialog
          v-model='youtubeDialog'
          max-width="640"
          max-height="360"
          class="pa-0 ma-0"
          >
            <template-youtube :item="videoItem" @closed="onDismissed"></template-youtube>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <v-dialog v-model="chatsMemberDialog"
        persistent
        max-width="800"
        >
        <chats-member-dialog
          v-if="chatsMemberDialog"
          @dismissed="onDismissed"
          @request="onRequest"
          :userref="parameter"
          :group="item"
          background="white"
        >
        </chats-member-dialog>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='eventDialog'
          persistent
          :max-width="'400px'">
          <app-event-edit
            v-if="eventDialog"
            @dismissed="onDismissed"
            :item="event"
            :dialog='eventDialog'
            :event="'event'"
          >
          </app-event-edit>
        </v-dialog>
      </v-layout>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='taskDialog'
          persistent
          :max-width="'400px'">
          <app-task-edit
            v-if="taskDialog"
            @dismissed="onDismissed"
            :item="task"
            :dialog='taskDialog'
            :task="'task'"
          >
          </app-task-edit>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <v-dialog v-model="studentViewDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-student-dialog
          v-if="studentViewDialog"
          @dismissed="onDismissed"
          :dialog='studentViewDialog'
          :item="openItem"
          :type="checkPrivileges('edit') ? 'edit' : 'view'"
        >
        </app-student-dialog>
      </v-dialog>
    </div>
  </v-row>
</template>

<script>
import Vue from 'vue'
import * as async from 'async'
import { mapGetters } from 'vuex'
import EmojiCmp from './EmojiPicker.vue'
import GoogleDrive from '../google/GoogleDrive.vue'
import moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/firestore'
import YouTube from '../../components/google/YouTube.vue'
import TemplateChatMember from './TemplateChatMember'
import ChatsMemberDialog from './ChatsMemberDialog'
import ImagePreview from '../../components/avatar/Avatar.vue'
import ScheduleMain from '../../views/schedule/Main.vue'
import EventEditDialog from '../../components/schedule/EventEditDialog.vue'
import TaskEditDialog from '../../components/schedule/TaskEditDialog.vue'
import Students from '../student/Students.vue'
import ChatSearchDialog from './ChatSearchDialog.vue'
import TemplateChatView from './TemplateChatView.vue'
Vue.component('template-youtube', YouTube)
Vue.component('app-emoji', EmojiCmp)
Vue.component('app-google-drive', GoogleDrive)
Vue.component('template-chat-member', TemplateChatMember)
Vue.component('chats-member-dialog', ChatsMemberDialog)
Vue.component('image-preview', ImagePreview)
Vue.component('schedule-main', ScheduleMain)
Vue.component('app-event-edit', EventEditDialog)
Vue.component('app-task-edit', TaskEditDialog)
Vue.component('app-student', Students)
Vue.component('app-chat-search-dialog', ChatSearchDialog)
Vue.component('template-chat-view', TemplateChatView)

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      chatRef: 'chatRef/chatRef',
      chatMessage: 'chatMessage/chatMessage',
      shares: 'shares/shares',
      chatRefStatus: 'chatRefStatus/chatRef',
      chatUnread: 'chatUnread/chatRef',
      windowSize: 'shared/windowSize',
      publicGroups: 'publicGroups/groups',
      publicUsers: 'publicUsers/users',
      scheduleEvents: 'scheduleEvents/events',
      templateEvents: 'templateEvents/templates',
      scheduleTasks: 'scheduleTasks/events',
      templateTasks: 'templateTasks/templates',
      students: 'students/students'
    }),
    chatsCreate () {
      if (!this.data) {
        return false
      }
      if (typeof this.data.chatsCreate !== 'undefined') {
        return this.data.chatsCreate
      }
      return false
    },
    chatsShare () {
      if (!this.data) {
        return false
      }
      if (typeof this.data.chatsShare !== 'undefined') {
        return this.data.chatsShare
      }
      return false
    },
    target () {
      const value = this[this.type]
      if (!isNaN(value)) return Number(value)
      else return value
    },
    chatsItems () {
      var temp = []
      for (var i in this.mySchools) {
        var payload = JSON.parse(JSON.stringify(this.mySchools[i]))
        if (this.checkStatus(payload)) {
          payload['chatType'] = 'school'
          payload['chatShare'] = 'no'
          payload['chatUpdate'] = this.getChatUpdate(this.mySchools[i])
          temp.push(payload)
        }
      }
      for (i in this.shareGroups) {
        payload = JSON.parse(JSON.stringify(this.shareGroups[i]))
        if (this.checkStatus(payload)) {
          payload['chatType'] = 'group'
          payload['chatShare'] = 'yes'
          payload['chatUpdate'] = this.getChatUpdate(this.shareGroups[i])
          temp.push(payload)
        }
      }
      for (i in this.publicClass) {
        payload = JSON.parse(JSON.stringify(this.publicClass[i]))
        if (this.checkStatus(payload)) {
          payload['chatType'] = 'group'
          payload['chatShare'] = 'no'
          payload['chatUpdate'] = this.getChatUpdate(this.publicClass[i])
          temp.push(payload)
        }
      }
      for (i in this.localClass) {
        payload = JSON.parse(JSON.stringify(this.localClass[i]))
        if (this.checkStatus(payload)) {
          payload['chatType'] = 'group'
          payload['chatShare'] = 'no'
          payload['chatUpdate'] = this.getChatUpdate(this.localClass[i])
          temp.push(payload)
        }
      }
      for (i in this.publicGroup) {
        payload = JSON.parse(JSON.stringify(this.publicGroup[i]))
        if (this.checkStatus(payload)) {
          payload['chatType'] = 'group'
          payload['chatShare'] = 'no'
          payload['chatUpdate'] = this.getChatUpdate(this.publicGroup[i])
          temp.push(payload)
        }
      }
      for (i in this.localGroup) {
        payload = JSON.parse(JSON.stringify(this.localGroup[i]))
        if (this.checkStatus(payload)) {
          payload['chatType'] = 'group'
          payload['chatShare'] = 'no'
          payload['chatUpdate'] = this.getChatUpdate(this.localGroup[i])
          temp.push(payload)
        }
      }
      for (i in this.myUsers) {
        payload = JSON.parse(JSON.stringify(this.myUsers[i]))
        if (this.checkStatus(payload)) {
          payload['chatType'] = 'user'
          payload['chatUpdate'] = this.getChatUpdate(this.myUsers[i])
          temp.push(payload)
        }
      }
      for (i in this.myPublicUsers) {
        var index = temp.findIndex(t => t.key === this.myPublicUsers[i].key)
        if (index !== -1) {
          continue
        }
        payload = JSON.parse(JSON.stringify(this.myPublicUsers[i]))
        if (this.checkStatus(payload)) {
          payload['chatType'] = 'user'
          payload['chatUpdate'] = this.getChatUpdate(this.myPublicUsers[i])
          temp.push(payload)
        }
      }
      temp.sort(function (a, b) {
        if (a.chatUpdate > b.chatUpdate) return -1
        if (a.chatUpdate < b.chatUpdate) return 1
        return 0
      })
      return temp
    },
    mySchools () {
      var temp = []
      if (this.data === null) {
        return temp
      }
      var keys = Object.keys(this.data.schools)
      for (var i in keys) {
        if (this.data.schools[keys[i]]) {
          var index = this.schools.findIndex(s => s.key === keys[i])
          if (index !== -1) {
            if (this.schools[index].public && this.schools[index].enable) {
              temp.push(JSON.parse(JSON.stringify(this.schools[index])))
              this.unreadNumber(this.schools[index], 'school')
            }
          }
        }
      }
      return temp
    },
    shareGroups () {
      var temp = []
      if (this.data === null) {
        return temp
      }
      if (!this.data.chatsShare) {
        return temp
      }
      for (var i in this.publicGroups) {
        if (this.publicGroups[i].owner === this.data.key) {
          if (this.publicGroups[i].enable) {
            temp.push(JSON.parse(JSON.stringify(this.publicGroups[i])))
            this.unreadNumber(this.publicGroups[i], 'group')
          }
        } else {
          if (this.publicGroups[i].public && this.publicGroups[i].enable) {
            temp.push(JSON.parse(JSON.stringify(this.publicGroups[i])))
            this.unreadNumber(this.publicGroups[i], 'group')
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
      })
      return temp
    },
    publicGroup () {
      var temp = []
      if (this.data === null) {
        return temp
      }
      for (var i in this.groups) {
        if (this.groups[i].public && this.groups[i].enable && !this.groups[i].classroom && !this.groups[i].chatsShare) {
          temp.push(JSON.parse(JSON.stringify(this.groups[i])))
          this.unreadNumber(this.groups[i], 'group')
        }
      }
      temp.sort(function (a, b) {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
      })
      return temp
    },
    localGroup () {
      var temp = []
      if (this.data === null) {
        return temp
      }
      for (var i in this.groups) {
        if (this.data.groups[this.groups[i].key] || this.groups[i].owner === this.data.key) {
          if (!this.groups[i].public && this.groups[i].enable && !this.groups[i].classroom && !this.groups[i].chatsShare) {
            temp.push(JSON.parse(JSON.stringify(this.groups[i])))
            this.unreadNumber(this.groups[i], 'group')
          }
        } else {
          var index = this.chatRef.findIndex(c => c.key === this.groups[i].key)
          if (index !== -1) {
            if (!this.groups[i].public && this.groups[i].enable && !this.groups[i].classroom && !this.groups[i].chatsShare && this.chatRef[index].enable) {
              temp.push(JSON.parse(JSON.stringify(this.groups[i])))
              this.unreadNumber(this.groups[i], 'group')
            }
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
      })
      return temp
    },
    publicClass () {
      var temp = []
      if (this.data === null) {
        return temp
      }
      var keys = Object.keys(this.data.groups)
      for (var i in keys) {
        if (this.data.groups[keys[i]]) {
          var index = this.groups.findIndex(g => g.key === keys[i])
          if (index !== -1) {
            if (this.groups[index].public && this.groups[index].enable) {
              temp.push(JSON.parse(JSON.stringify(this.groups[index])))
              this.unreadNumber(this.groups[index], 'group')
            }
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
      })
      return temp
    },
    localClass () {
      var temp = []
      if (this.data === null) {
        return temp
      }
      var keys = Object.keys(this.data.groups)
      for (var i in keys) {
        if (this.data.groups[keys[i]]) {
          var index = this.groups.findIndex(g => g.key === keys[i])
          if (index !== -1) {
            if (!this.groups[index].public && this.groups[index].enable) {
              temp.push(JSON.parse(JSON.stringify(this.groups[index])))
              this.unreadNumber(this.groups[index], 'group')
            }
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
      })
      return temp
    },
    myUsers () {
      var temp = []
      for (var i in this.users) {
        if (this.users[i].enable && this.users[i].public && this.users[i].key !== this.user.uid) {
          temp.push(JSON.parse(JSON.stringify(this.users[i])))
          this.unreadNumber(this.users[i], 'user')
        }
      }
      temp.sort(function (a, b) {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
      })
      return temp
    },
    myPublicUsers () {
      var temp = []
      for (var i in this.publicUsers) {
        if (this.publicUsers[i].enable && this.publicUsers[i].public && this.publicUsers[i].key !== this.user.uid) {
          if (this.data.chatsCreate) {
            temp.push(JSON.parse(JSON.stringify(this.publicUsers[i])))
            this.unreadNumber(this.publicUsers[i], 'user')
          } else {
            var index = this.myUsers.findIndex(mu => mu.key === this.publicUsers[i].key)
            if (index !== -1) {
              continue
            }
            index = this.chatRefStatus.findIndex(c => c.key === this.user.uid)
            if (index !== -1) {
              if (this.chatRefStatus[index].members[this.publicUsers[i].key]) {
                temp.push(JSON.parse(JSON.stringify(this.publicUsers[i])))
                this.unreadNumber(this.publicUsers[i], 'user')
              }
            }
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
      })
      return temp
    },
    myMembers () {
      var temp = []
      if (this.item) {
        if (this.item.chatsShare) {
          var index = this.chatRefStatus.findIndex(c => c.key === this.item.key)
          if (index !== -1) {
            var keys = Object.keys(this.chatRefStatus[index].members)
            for (var i in keys) {
              if (keys[i] !== this.user.uid) {
                index = this.publicUsers.findIndex(u => u.key === keys[i])
                if (index !== -1) {
                  temp.push({
                    name: this.publicUsers[index].name,
                    key: keys[i]
                  })
                }
              }
            }
          }
        } else {
          index = this.chatRefStatus.findIndex(c => c.key === this.item.key)
          if (index !== -1) {
            keys = Object.keys(this.chatRefStatus[index].members)
            for (i in keys) {
              if (keys[i] !== this.user.uid) {
                index = this.users.findIndex(u => u.key === keys[i])
                if (index !== -1) {
                  temp.push({
                    name: this.users[index].name,
                    key: keys[i]
                  })
                }
              }
            }
          }
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 58 - 40) + 'px;'
    },
    chatsContentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 58 - 234 - 40) + 'px;'
    },
    filteredCounts () {
      var temp = {}
      for (var i in this.filteredMessages) {
        var key = this.filteredMessages[i].from
        if (this.filteredMessages[i].chatType === 'group' || this.filteredMessages[i].chatType === 'school') {
          key = this.filteredMessages[i].to
        } else {
          if (this.filteredMessages[i].to !== this.user.uid) {
            key = this.filteredMessages[i].to
          }
        }
        if (!temp[key]) {
          temp[key] = 1
        } else {
          temp[key] += 1
        }
      }
      return temp
    },
    filteredItems () {
      var temp = []
      for (var i in this.mySchools) {
        if (this.filteredCounts[this.mySchools[i].key]) {
          var s = JSON.parse(JSON.stringify(this.mySchools[i]))
          s['chatType'] = 'school'
          s['chatShare'] = 'no'
          temp.push(s)
        }
      }
      for (i in this.shareGroups) {
        if (this.filteredCounts[this.shareGroups[i].key]) {
          s = JSON.parse(JSON.stringify(this.shareGroups[i]))
          s['chatType'] = 'group'
          s['chatShare'] = 'yes'
          temp.push(s)
        }
      }
      for (i in this.publicClass) {
        if (this.filteredCounts[this.publicClass[i].key]) {
          s = JSON.parse(JSON.stringify(this.publicClass[i]))
          s['chatType'] = 'group'
          s['chatShare'] = 'no'
          temp.push(s)
        }
      }
      for (i in this.localClass) {
        if (this.filteredCounts[this.localClass[i].key]) {
          s = JSON.parse(JSON.stringify(this.localClass[i]))
          s['chatType'] = 'group'
          s['chatShare'] = 'no'
          temp.push(s)
        }
      }
      for (i in this.publicGroup) {
        if (this.filteredCounts[this.publicGroup[i].key]) {
          s = JSON.parse(JSON.stringify(this.publicGroup[i]))
          s['chatType'] = 'group'
          s['chatShare'] = 'no'
          temp.push(s)
        }
      }
      for (i in this.localGroup) {
        if (this.filteredCounts[this.localGroup[i].key]) {
          s = JSON.parse(JSON.stringify(this.localGroup[i]))
          s['chatType'] = 'group'
          s['chatShare'] = 'no'
          temp.push(s)
        }
      }
      for (i in this.myUsers) {
        if (this.filteredCounts[this.myUsers[i].key]) {
          s = JSON.parse(JSON.stringify(this.myUsers[i]))
          s['chatType'] = 'user'
          s['chatShare'] = 'no'
          temp.push(s)
        }
      }
      for (i in this.myPublicUsers) {
        if (this.filteredCounts[this.myPublicUsers[i].key]) {
          var index = temp.findIndex(t => t.key === this.myPublicUsers[i].key)
          if (index !== -1) {
            continue
          }
          s = JSON.parse(JSON.stringify(this.myPublicUsers[i]))
          s['chatType'] = 'user'
          s['chatShare'] = 'yes'
          temp.push(s)
        }
      }
      return temp
    },
    displayMessages () {
      var temp = []
      if (this.parameter) {
        for (var i in this.filteredMessages) {
          var key = this.filteredMessages[i].from
          if (this.filteredMessages[i].chatType === 'group' || this.filteredMessages[i].chatType === 'school') {
            key = this.filteredMessages[i].to
          } else {
            if (this.filteredMessages[i].to !== this.user.uid) {
              key = this.filteredMessages[i].to
            }
          }
          if (this.parameter.key === key) {
            temp.push(this.filteredMessages[i])
          }
        }
      } else {
        temp = this.filteredMessages
      }
      return temp
    },
    filteredMessages () {
      var temp = []
      for (var i in this.searchMessages) {
        if (this.searchMessages[i].type === 'text' && this.searchMessages[i].content !== null && this.searchMessages[i].content.indexOf(this.search) !== -1) {
          temp.push(JSON.parse(JSON.stringify(this.searchMessages[i])))
        } else if (typeof this.searchMessages[i].note !== 'undefined' && this.searchMessages[i].note !== null) {
          if (this.searchMessages[i].note.indexOf(this.search) !== -1) {
            temp.push(JSON.parse(JSON.stringify(this.searchMessages[i])))
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.createdAt > b.createdAt) return 1
        if (a.createdAt < b.createdAt) return -1
        return 0
      })
      return temp
    }
  },
  data () {
    return {
      members: [],
      tempUser: null,
      search: null,
      searchDialog: false,
      visible: false,
      unReadGroup: {},
      unReadUser: {},
      imageDialog: false,
      imageUrl: null,
      file: null,
      emojiDialog: false,
      emoji: null,
      loading: false,
      requestDialog: false,
      shareDialog: false,
      youtubeDialog: false,
      alertDialog: false,
      chatsMemberDialog: false,
      scheduleDialog: false,
      eventDialog: false,
      taskDialog: false,
      studentDialog: false,
      studentViewDialog: false,
      videoItem: null,
      id: null,
      item: null,
      remove: null,
      removeDialog: false,
      status: null,
      dialog: false,
      message: '',
      title: '',
      requestMessage: '',
      offsetTop: 0,
      type: 'dialog',
      openItem: null,
      parameter: null,
      messages: [],
      searchMessages: [],
      shareItem: null,
      scheduleItem: null,
      studentItem: null,
      event: null,
      task: null,
      emojiType: null,
      edit: null,
      url: null
    }
  },
  watch: {
    chatMessage () {
      this.messages = []
      var temp = []
      if (this.parameter) {
        for (var index in this.chatMessage[this.parameter.location]) {
          Vue.set(temp, index, this.chatMessage[this.parameter.location][index])
        }
      }
      temp.sort(function (a, b) {
        if (a.createdAt > b.createdAt) return 1
        if (a.createdAt < b.createdAt) return -1
        return 0
      })
      this.messages = temp
    },
    chatRef () {
      if (this.item) {
        var index = this.chatRef.findIndex(c => c.key === this.item.key)
        if (index === -1) {
          this.item = null
          this.parameter = null
          this.messages = []
        } else {
          this.parameter = this.chatRef[index]
          this.messageRead()
        }
      }
    },
    students () {
      if (this.studentViewDialog) {
        var index = this.students.findIndex(s => s.key === this.openItem.key)
        if (index !== -1) {
          this.openItem = JSON.parse(JSON.stringify(this.students[index]))
        }
      }
    },
    data () {
      this.tempUser = JSON.parse(JSON.stringify(this.data))
      if (typeof this.tempUser.chatFilter === 'undefined') {
        Vue.set(this.tempUser, 'chatFilter', false)
      }
    }
  },
  created () {
    this.tempUser = JSON.parse(JSON.stringify(this.data))
    if (typeof this.tempUser.chatFilter === 'undefined') {
      Vue.set(this.tempUser, 'chatFilter', false)
    }
  },
  methods: {
    subscribeMessage (ref) {
      var vm = this
      var offset = null
      return new Promise((resolve) => {
        switch (ref.type) {
          case 'school':
            offset = vm.schools.findIndex(schools => schools.key === ref.key)
            if (offset !== -1) {
              vm.loading = true
              vm.$store.dispatch('chatMessage/subscribe', ref.location).then(() => {
                vm.loading = false
                resolve()
              })
            } else {
              resolve()
            }
            break
          case 'group':
            offset = vm.groups.findIndex(group => group.key === ref.key)
            if (offset !== -1) {
              vm.loading = true
              vm.$store.dispatch('chatMessage/subscribe', ref.location).then(() => {
                vm.loading = false
                resolve()
              })
            } else {
              offset = vm.publicGroups.findIndex(group => group.key === ref.key)
              if (offset !== -1) {
                vm.loading = true
                vm.$store.dispatch('chatMessage/subscribe', ref.location).then(() => {
                  vm.loading = false
                  resolve()
                })
              } else {
                resolve()
              }
            }
            break
          case 'user':
            offset = vm.users.findIndex(user => user.key === ref.key)
            if (offset !== -1) {
              vm.loading = true
              vm.$store.dispatch('chatMessage/subscribe', ref.location).then(() => {
                vm.loading = false
                resolve()
              })
            } else {
              offset = vm.publicUsers.findIndex(user => user.key === ref.key)
              if (offset !== -1) {
                vm.loading = true
                vm.$store.dispatch('chatMessage/subscribe', ref.location).then(() => {
                  vm.loading = false
                  resolve()
                })
              } else {
                resolve()
              }
            }
            break
        }
      })
    },
    checkPrivilege () {
      if (this.item.chatsShare && this.chatsCreate && this.parameter && this.parameter.type === 'group' && this.data && this.item.owner === this.data.key) {
        return true
      }
      if (!this.item.classroom && this.parameter && this.parameter.type === 'group' && this.data && this.item.owner === this.data.key) {
        return true
      }
      return false
    },
    getChatUpdate (item) {
      var update = null
      var index = this.chatRef.findIndex(c => c.key === item.key)
      if (index !== -1) {
        index = this.chatUnread.findIndex(c => c.key === this.chatRef[index].location)
        if (index !== -1) {
          update = this.chatUnread[index].updatedAt ? this.chatUnread[index].updatedAt : null
        }
      }
      return update
    },
    getMember (item) {
      var index = this.chatRefStatus.findIndex(c => c.key === item.key)
      if (index !== -1) {
        return this.chatRefStatus[index].member
      }
      return 0
    },
    getMemberList (item) {
      var temp = []
      var index = this.chatRefStatus.findIndex(c => c.key === item.key)
      if (index !== -1) {
        var keys = Object.keys(this.chatRefStatus[index].members)
        for (var i in keys) {
          var uidx = this.users.findIndex(u => u.key === keys[i])
          if (uidx !== -1) {
            var name = ''
            if (this.users[uidx].key === item.owner) {
              name = '◎ '
            }
            temp.push(name + this.users[uidx].name)
            continue
          }
          uidx = this.publicUsers.findIndex(u => u.key === keys[i])
          if (uidx !== -1) {
            name = ''
            if (this.publicUsers[uidx].key === item.owner) {
              name = '◎ '
            }
            temp.push(name + this.publicUsers[uidx].name)
          }
        }
      }
      return temp
    },
    getUserName (item) {
      var index = null
      if (this.item.chatsShare) {
        index = this.publicUsers.findIndex(u => u.key === item)
        if (index !== -1) {
          return this.publicUsers[index].name
        }
      } else {
        index = this.users.findIndex(u => u.key === item)
        if (index !== -1) {
          return this.users[index].name
        }
      }
      return ''
    },
    unreadNumber (item, type) {
      if (typeof item === 'undefined') {
        return 0
      }
      var index = this.chatRef.findIndex(ref => ref.key === item.key)
      if (index === -1) {
        return 0
      }
      var offset = this.chatUnread.findIndex(c => c.key === this.chatRef[index].location)
      if (offset === -1) {
        return 0
      }
      var key = item.key
      key = this.user.uid
      var counter = 0
      if (typeof this.chatUnread[offset].unread[key] !== 'undefined') {
        counter = this.chatUnread[offset].unread[key]
      } else {
        counter = this.chatUnread[offset].total
      }
      Vue.set(this.unReadUser, item.key, counter)
      return counter
    },
    getCounter (item) {
      if (!item.read) {
        return '未読'
      }
      if (item.chatType === 'user' || !item.whoRead) {
        return '既読'
      }
      return '既読 ' + String(item.whoRead.length)
    },
    getMimeType () {
      var mime = 'mdi-file-document-box-outline'
      if (this.shareItem.selected === 1) {
        if (typeof this.$MIMEICON[this.shareItem.item.mimeType] !== 'undefined') {
          mime = this.$MIMEICON[this.shareItem.item.mimeType]
        }
      } else if (this.shareItem.selected === 9) {
        if (typeof this.$MIMEICON[this.shareItem.item.contents.mimeType] !== 'undefined') {
          mime = this.$MIMEICON[this.shareItem.item.contents.mimeType]
        } else {
          mime = 'mdi-folder'
        }
      } else {
        if (typeof this.$MIMEICON[this.shareItem.item.contents.mimeType] !== 'undefined') {
          mime = this.$MIMEICON[this.shareItem.item.contents.mimeType]
        }
      }
      return mime
    },
    checkShareItem () {
      if (this.shareItem) {
        if (this.shareItem.item !== null) {
          return true
        }
      }
      return false
    },
    getShareItemName () {
      if (this.shareItem) {
        if (this.shareItem.item !== null) {
          return this.shareItem.item.name
        }
      }
      return ''
    },
    sendSub (type, content, title) {
      var vm = this
      this.loading = true
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        var dbRef = db.collection('chats').doc(this.parameter.location).collection('data')
        const payload = {
          chatType: this.parameter.type,
          content: content,
          from: this.user.uid,
          fromName: this.data.name,
          to: this.parameter.key,
          read: false,
          whoRead: {},
          attention: this.members,
          type: type,
          visible: true,
          note: type === 'text' ? null : this.message,
          title: title,
          createdAt: parseInt(new Date().getTime()),
          updatedAt: parseInt(new Date().getTime())
        }
        if (type === 'photo' && vm.file !== null) {
          vm.$store.dispatch('storage/write', { blob: vm.file, child: 'chats', id: vm.parameter.location, refid: this.genUUIDv4() }).then((resp) => {
            if (resp) {
              payload.content = resp
              dbRef.add(payload).then(function () {
                vm.loading = false
                vm.onClear()
                resolve()
              })
                .catch(function (error) {
                  if (error) {
                    // console.log(error)
                  }
                  vm.loading = false
                  resolve()
                })
            }
          })
        } else {
          dbRef.add(payload).then(function () {
            vm.loading = false
            vm.onClear()
            resolve()
          })
            .catch(function (error) {
              if (error) {
                // console.log(error)
              }
              vm.loading = false
              resolve()
            })
        }
      })
    },
    send () {
      if (this.edit) {
        this.update()
        return
      }
      if (this.file !== null) {
        this.sendSub('photo', '', '').then(() => {
        })
      } else if (this.checkShareItem()) {
        if (this.shareItem.selected === 1) {
          this.sendSub('drive', this.shareItem.item, '共有：「' + this.shareItem.item.name + '」').then(() => {
          })
        } else {
          this.sendSub('share', this.shareItem.item.key, '共有：「' + this.shareItem.item.name + '」').then(() => {
          })
        }
      } else if (this.emoji !== null) {
        this.sendSub('emoji', this.emoji, null).then(() => {
        })
      } else if (this.scheduleItem !== null) {
        this.sendSub('task', { type: this.scheduleItem.type, key: this.scheduleItem.key }, '計画：「' + this.scheduleItem.startDate + '：' + this.scheduleItem.title + '」').then(() => {
        })
      } else if (this.studentItem !== null) {
        this.sendSub('student', this.studentItem.key, '生徒：「' + this.studentItem.name + ' ' + this.getGradeName(this.getGrade(this.studentItem)) + '」').then(() => {
        })
      } else if (this.message !== '') {
        this.sendSub('text', this.message, null).then(() => {
        })
      }
    },
    updateSub (type, content, title) {
      var vm = this
      this.loading = true
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var dbRef = db.collection('chats').doc(this.parameter.location).collection('data').doc(this.edit.key)
        const payload = {
          content: content,
          attention: this.members,
          note: type === 'text' ? null : this.message,
          title: title,
          type: type,
          updatedAt: parseInt(new Date().getTime())
        }
        if (type === 'photo' && vm.file !== null) {
          vm.$store.dispatch('storage/write', { blob: vm.file, child: 'chats', id: vm.parameter.location, refid: this.genUUIDv4() }).then((resp) => {
            if (resp) {
              payload.content = resp
              dbRef.update(payload).then(function () {
                vm.loading = false
                vm.onClear()
                resolve()
              })
                .catch(function (error) {
                  if (error) {
                    // console.log(error)
                  }
                  vm.loading = false
                  resolve()
                })
            }
          })
        } else {
          dbRef.update(payload).then(function () {
            vm.loading = false
            vm.onClear()
            resolve()
          })
            .catch(function (error) {
              if (error) {
                // console.log(error)
              }
              vm.loading = false
              resolve()
            })
        }
      })
    },
    update () {
      if (this.file !== null || this.url) {
        this.updateSub('photo', this.edit.content, '').then(() => {
        })
      } else if (this.checkShareItem()) {
        if (this.shareItem.selected === 1) {
          this.updateSub('drive', this.shareItem.item, '共有：「' + this.shareItem.item.name + '」').then(() => {
          })
        } else {
          this.updateSub('share', this.shareItem.item.key, '共有：「' + this.shareItem.item.name + '」').then(() => {
          })
        }
      } else if (this.emoji !== null) {
        this.updateSub('emoji', this.emoji, null).then(() => {
        })
      } else if (this.scheduleItem !== null) {
        this.updateSub('task', { type: this.scheduleItem.type, key: this.scheduleItem.key }, '計画：「' + this.scheduleItem.startDate + '：' + this.scheduleItem.title + '」').then(() => {
        })
      } else if (this.studentItem !== null) {
        this.updateSub('student', this.studentItem.key, '生徒：「' + this.studentItem.name + ' ' + this.getGradeName(this.getGrade(this.studentItem)) + '」').then(() => {
        })
      } else if (this.message !== '') {
        this.updateSub('text', this.message, null).then(() => {
        })
      }
    },
    setRead (item) {
      var vm = this
      const db = firebase.firestore()
      if (item.read) {
        if (item.whoRead && item.whoRead[this.user.uid]) {
          return
        }
        var dbRef = db.collection('chats').doc(item.parentKey).collection('data').doc(item.key)
        dbRef.update({
          whoRead: firebase.firestore.FieldValue.arrayUnion(vm.user.uid)
        })
        return
      }
      dbRef = db.collection('chats').doc(item.parentKey).collection('data').doc(item.key)
      var payload = {
        read: true,
        updatedAt: parseInt(new Date().getTime())
      }
      dbRef.update(payload).then(function () {
        var dbRef = db.collection('chats').doc(item.parentKey).collection('data').doc(item.key)
        dbRef.update({
          whoRead: firebase.firestore.FieldValue.arrayUnion(vm.user.uid)
        })
      })
    },
    checkStatus (item) {
      if (this.tempUser.chatFilter) {
        return this.getStatus(item) === 'accepting'
      }
      return true
    },
    getStatus (item) {
      for (var i in this.chatRef) {
        if (this.chatRef[i].key === item.key) {
          return this.chatRef[i].status
        }
      }
      return 'none'
    },
    getSchool (item) {
      for (var key in item.schools) {
        if (item.schools[key]) {
          var index = this.schools.findIndex(school => school.key === key)
          if (index !== -1) {
            return this.schools[index].name
          }
        }
      }
      return ''
    },
    getAvatar (item) {
      var index = -1
      var url = null
      if (this.item.chatsShare) {
        index = this.publicUsers.findIndex(user => user.key === item.from)
        if (index !== -1) {
          if (this.publicUsers[index].avatar) {
            url = this.publicUsers[index].avatar.thumbnail
          }
        }
      } else {
        index = this.users.findIndex(user => user.key === item.from)
        if (index !== -1) {
          if (this.users[index].avatar) {
            url = this.users[index].avatar.thumbnail
          }
        }
      }
      return url
    },
    getFromUserName (item) {
      var index = -1
      var name = '？'
      if (this.item.chatsShare) {
        index = this.publicUsers.findIndex(user => user.key === item.from)
        if (index !== -1) {
          name = this.publicUsers[index].name
        }
      } else {
        index = this.users.findIndex(user => user.key === item.from)
        if (index !== -1) {
          name = this.users[index].name
        }
      }
      return name
    },
    getNamePrefix (item) {
      var index = -1
      var name = '？'
      if (this.item.chatsShare) {
        index = this.publicUsers.findIndex(user => user.key === item.from)
        if (index !== -1) {
          name = this.publicUsers[index].name.slice(0, 1)
        }
      } else {
        index = this.users.findIndex(user => user.key === item.from)
        if (index !== -1) {
          name = this.users[index].name.slice(0, 1)
        }
      }
      return name
    },
    getNamePrefixFromItem (item) {
      var name = '？'
      if (item.name) {
        name = item.name.slice(0, 1)
      }
      return name
    },
    getTaskColor (item) {
      var index = -1
      if (item.type === 'event') {
        index = this.scheduleEvents.findIndex(event => event.key === item.key)
        if (index !== -1) {
          var template = this.scheduleEvents[index].template
          index = this.templateEvents.findIndex(event => event.key === template)
          if (index !== -1) {
            return 'background-color: ' + this.getDescriptionColor(this.templateEvents[index], this.$COLOR_DEFAULT) + '; '
          }
        }
      } else {
        index = this.scheduleTasks.findIndex(event => event.key === item.key)
        if (index !== -1) {
          template = this.scheduleTasks[index].template
          index = this.templateTasks.findIndex(event => event.key === template)
          if (index !== -1) {
            var task = this.templateTasks[index]
            const bg = 'background-color: ' + this.getDescriptionColor(task, this.$COLOR_LIGHT) + '; '
            const border = 'border: 1px solid ' + this.getDescriptionColor(task, this.$COLOR_DEFAULT) + '; '
            const font = 'color: ' + this.getDescriptionColor(task, this.$COLOR_DARK) + '; '
            return bg + border + font
          }
        }
      }
      return 'background-color: #9E9E9E;'
    },
    getTextLength () {
      var len = 0
      if (this.message) {
        len = this.message.length
      }
      return len
    },
    clearMessage () {
      this.message = ''
      this.file = null
    },
    onChangeChatFilter () {
      this.tempUser.chatFilter = !this.tempUser.chatFilter
      const db = firebase.firestore()
      var dbRef = db.collection('users').doc(this.data.key)
      var payload = {
        chatFilter: this.tempUser.chatFilter,
        updatedAt: parseInt(new Date().getTime())
      }
      dbRef.update(payload).then(function () {
      })
    },
    onClear () {
      this.file = null
      this.shareItem = null
      this.message = ''
      this.emoji = null
      this.members = []
      this.scheduleItem = null
      this.studentItem = null
      this.edit = null
      this.url = null
    },
    checkIfSend () {
      return this.file || this.url || this.shareItem || (this.message && this.message.length > 0) || this.emoji || this.scheduleItem || this.studentItem
    },
    checkIfCancel () {
      return this.edit || this.file || this.url || (this.message && this.message !== '') || this.emoji || this.scheduleItem || this.studentItem || this.shareItem
    },
    messageRead () {
      var vm = this
      var keys = Object.keys(this.chatMessage)
      var index = keys.indexOf(this.parameter.location)
      if (index !== -1) {
        this.messages = []
        var temp = []
        for (index in this.chatMessage[this.parameter.location]) {
          Vue.set(temp, index, this.chatMessage[this.parameter.location][index])
        }
        temp.sort(function (a, b) {
          if (a.createdAt > b.createdAt) return 1
          if (a.createdAt < b.createdAt) return -1
          return 0
        })
        this.messages = temp
      } else {
        this.messages = []
        temp = []
        this.subscribeMessage(this.parameter).then(() => {
          for (index in vm.chatMessage[vm.parameter.location]) {
            Vue.set(temp, index, vm.chatMessage[vm.parameter.location][index])
          }
          temp.sort(function (a, b) {
            if (a.createdAt > b.createdAt) return 1
            if (a.createdAt < b.createdAt) return -1
            return 0
          })
          this.messages = temp
        })
      }
    },
    onSelect: function (item) {
      if (this.item && item.key === this.item.key) {
        return
      }
      this.item = item
      this.members = []
      var index = this.chatRef.findIndex(ref => ref.key === item.key)
      if (index === -1) {
        this.messages = []
        this.parameter = null
        return
      }
      this.parameter = this.chatRef[index]
      if (!this.searchDialog) {
        this.messageRead()
      }
    },
    changeIcon () {
      this.dialog = true
    },
    onSearch () {
      if (this.search) {
        this.parameter = null
        this.item = null
        this.members = []
        this.messages = []
        this.searchDialog = true
        this.searchChatMessage()
      }
    },
    onSearchClear () {
      this.searchDialog = false
      this.parameter = null
      this.item = null
      this.members = []
      this.messages = []
    },
    onShareDialog () {
      this.type = 'dialog'
      this.openItem = null
      this.shareDialog = true
    },
    onScroll (e) {
      this.$nextTick(() => {
        this.offsetTop = e.target.scrollTop
      })
    },
    onChangeItem: function (value) {
      if (this.shareDialog) {
        this.shareItem = value
      }
      if (this.scheduleDialog) {
        this.scheduleItem = value.item
      }
      if (this.studentDialog) {
        this.studentItem = value.item
      }
    },
    onDismissed: function (value) {
      if (this.removeDialog) {
        this.removeDialog = false
        if (value) {
          this.onRemove()
        }
        return
      }
      this.dialog = false
      this.youtubeDialog = false
      this.emojiDialog = false
      this.chatsMemberDialog = false
      this.eventDialog = false
      this.taskDialog = false
      this.studentViewDialog = false
    },
    onEmoji: function (emoji) {
      if (this.emojiType === 'inline') {
        if (this.message === null) {
          this.message = ''
        }
        this.message = this.message + emoji
      } else {
        this.emoji = emoji
      }
    },
    onRequest: function (value) {
      this.status = this.getStatus(value.item)
      this.item = value.item
      this.members = []
      this.messages = []
      this.parameter = null

      var index = this.chatRef.findIndex(ref => ref.key === this.item.key)
      if (index !== -1) {
        this.parameter = this.chatRef[index]
      }
      if (this.status === 'none') {
        this.title = value.id === 'user' ? '追加' : '参加'
        this.requestMessage = value.id === 'user' ? '「' + value.item.name + '」' + ' さんの伝言へのアクセスを要望します。よろしいですか?' : '「' + value.item.name + '」' + 'へ参加します。よろしいですか?'
      } else if (this.status === 'requesting') {
        this.title = '承認'
        this.requestMessage = '「' + value.item.name + '」' + ' さんから伝言へのアクセス要望がきています。承認しますか?'
      } else if (this.status === 'accepting') {
        this.title = '削除'
        this.requestMessage = '「' + value.item.name + '」' + ' 伝言へのアクセス権を削除します。よろしいですか?'
      }
      this.id = value.id
      this.requestDialog = true
    },
    follow (item, id) {
      var vm = this
      var payload = null
      this.requestDialog = false
      this.$nextTick(function () {
        vm.loading = true
        if (vm.status === 'none') {
          payload = {
            from: vm.user.uid,
            to: item,
            type: id,
            schools: vm.data.schools
          }
          vm.$store.dispatch('chatRef/follow', payload).then(() => {
            vm.loading = false
          })
        } else if (this.status === 'requesting') {
          payload = {
            from: vm.user.uid,
            to: item,
            type: id,
            schools: vm.data.schools
          }
          vm.$store.dispatch('chatRef/accept', payload).then(() => {
            vm.loading = false
          })
        } else if (this.status === 'accepting') {
          payload = {
            from: vm.user.uid,
            to: item,
            type: id,
            parameter: vm.parameter
          }
          vm.$store.dispatch('chatRef/unfollow', payload).then(() => {
            vm.item = null
            vm.members = []
            vm.messages = []
            vm.parameter = null
            vm.loading = false
          })
        }
      })
    },
    onOpenItem: function (value) {
      var item = value.item
      var index = -1
      if (item.type === 'task') {
        if (item.content.type === 'event') {
          index = this.scheduleEvents.findIndex(event => event.key === item.content.key)
          if (index !== -1) {
            this.event = JSON.parse(JSON.stringify(this.scheduleEvents[index]))
            this.eventDialog = true
          }
        } else {
          index = this.scheduleTasks.findIndex(event => event.key === item.content.key)
          if (index !== -1) {
            this.task = JSON.parse(JSON.stringify(this.scheduleTasks[index]))
            this.taskDialog = true
          }
        }
        return
      } else if (item.type === 'student') {
        index = this.students.findIndex(s => s.key === item.content)
        if (index !== -1) {
          this.openItem = JSON.parse(JSON.stringify(this.students[index]))
          if (this.openItem.enable) {
            this.studentViewDialog = true
          }
        }
        return
      } else if (item.type === 'share') {
        index = this.shares.findIndex(share => share.key === item.content)
        if (index === -1) {
          return null
        }
      } else if (item.type === 'drive') {
        window.open(item.content.webViewLink, '_blank')
        this.itemLogs(item.content.id)
        return
      }
      if (this.shares[index].type === 'youtube') {
        if (this.shares[index].contents.mimeType !== null && this.shares[index].contents.video !== null) {
          this.videoItem = JSON.parse(JSON.stringify(this.shares[index]))
          this.youtubeDialog = true
          this.itemLogs(this.videoItem.contents.video)
        } else {
          this.type = 'open'
          this.openItem = this.shares[index]
          this.shareDialog = true
        }
      } else if (this.shares[index].type === 'drive') {
        if (this.shares[index].contents.mimeType === 'application/vnd.google-apps.folder') {
          this.type = 'open'
          this.openItem = this.shares[index]
          this.shareDialog = true
        } else {
          window.open(this.shares[index].contents.webViewLink, '_blank')
          this.itemLogs(this.shares[index].contents.id)
        }
      }
    },
    itemLogs (key) {
      var payload = {
        key: key,
        status: true,
        uid: this.user.uid
      }
      this.$store.dispatch('sharesStatics/update', payload)
    },
    onOpenImage: function (value) {
      this.imageUrl = value.item.content.path
      this.imageDialog = true
    },
    onEdit: function (value) {
      this.onClear()
      this.edit = value.item
      this.members = this.edit.attention
      this.message = this.edit.note
      switch (this.edit.type) {
        case 'photo':
          this.url = this.edit.content.path
          break
        case 'drive':
          this.shareItem = { selected: 1, item: JSON.parse(JSON.stringify(this.edit.content)) }
          break
        case 'share':
          var index = this.shares.findIndex(s => s.key === this.edit.content)
          if (index !== -1) {
            this.shareItem = { selected: this.shares[index].category + 4, item: JSON.parse(JSON.stringify(this.shares[index])) }
            if (this.shares[index].type === 'youtube') {
              this.shareItem.selected = 9
            }
          }
          break
        case 'emoji':
          this.emoji = this.edit.content
          break
        case 'task':
          if (this.edit.content.type === 'event') {
            index = this.scheduleEvents.findIndex(s => s.key === this.edit.content.key)
            if (index !== -1) {
              this.scheduleItem = JSON.parse(JSON.stringify(this.scheduleEvents[index]))
              index = this.templateEvents.findIndex(ev => ev.key === this.scheduleItem.template)
              if (index !== -1) {
                this.scheduleItem['category'] = this.templateEvents[index].category
                this.scheduleItem['period'] = this.templateEvents[index].period
                this.scheduleItem['title'] = this.templateEvents[index].title
                this.scheduleItem['description'] = this.templateEvents[index].description
                this.scheduleItem['schools'] = this.templateEvents[index].schools
              }
            }
          } else if (this.edit.content.type === 'task') {
            index = this.scheduleTasks.findIndex(s => s.key === this.edit.content.key)
            if (index !== -1) {
              this.scheduleItem = JSON.parse(JSON.stringify(this.scheduleTasks[index]))
              index = this.templateTasks.findIndex(task => task.key === this.scheduleItem.template)
              if (index !== -1) {
                this.scheduleItem['category'] = this.templateTasks[index].category
                this.scheduleItem['action'] = this.templateTasks[index].action
                this.scheduleItem['title'] = this.templateTasks[index].title
                this.scheduleItem['description'] = this.templateTasks[index].description
                this.scheduleItem['schools'] = this.templateTasks[index].schools
              }
            }
          }
          break
        case 'student':
          index = this.students.findIndex(s => s.key === this.edit.content)
          if (index !== -1) {
            this.studentItem = JSON.parse(JSON.stringify(this.students[index]))
          }
          break
        case 'text':
          this.message = this.edit.content
          break
      }
    },
    onRemoveDialog: function (value) {
      this.remove = value.item
      this.removeDialog = true
    },
    onRemove () {
      this.removeDialog = false
      if (!this.remove) {
        return
      }
      const db = firebase.firestore()
      var dbRef = db.collection('chats').doc(this.remove.parentKey).collection('data').doc(this.remove.key)
      const payload = {
        visible: false,
        updatedAt: parseInt(new Date().getTime())
      }
      dbRef.update(payload).then(function () {
      })
    },
    onSearchSub (chatRef) {
      var vm = this
      const db = firebase.firestore()
      return new Promise((resolve) => {
        var ref = db.collection('chats').doc(chatRef.location).collection('data').where('visible', '==', true)
        ref.get().then(function (snapshots) {
          async.eachSeries(snapshots.docs, function (chat, cb) {
            var data = JSON.parse(JSON.stringify(chat.data()))
            data['parent'] = JSON.parse(JSON.stringify(chatRef))
            vm.searchMessages.push(data)
            cb()
          }, function (error) {
            if (error) {
              // console.log(error)
            }
            resolve()
          })
        })
      })
    },
    searchChatMessage () {
      this.searchMessages = []
      var vm = this
      this.loading = true
      const db = firebase.firestore()
      var dbRef = db.collection('chats_refs').doc(this.user.uid).collection('refs')
      dbRef.get().then(function (snapshots) {
        async.eachSeries(snapshots.docs, function (chat, cb) {
          var ref = JSON.parse(JSON.stringify(chat.data()))
          if (ref.enable && ref.status === 'accepting') {
            vm.onSearchSub(ref).then(() => {
              cb()
            })
          } else {
            cb()
          }
        }, function (error) {
          if (error) {
            // console.log(error)
          }
          vm.loading = false
        })
      })
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MM月DD日 HH時mm分')
    }
  }
}
</script>

<style scoped>
.v-image {
  cursor: pointer;
}
img {
  object-fit: cover !important;
}
p.delete {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 8px;
  border-width: 1px;
  border: 1px solid;
  text-align:center;
  margin: 2px;
  color: red;
  font-size: 9px;
  width: 40px;
  height: 14px;
  user-select: none !important;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
  cursor: pointer;
}

p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none !important;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

p.read {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 8px;
  padding-left: 6px;
  margin: 2px;
  font-size: 9px;
  width: 40px;
  height: 12px;
  color: aliceblue;
  text-align: center;
  user-select: none !important;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

p.name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 8px;
  /* border-width: 1px; */
  /* border: 1px solid; */
  text-align:center;
  margin: 2px;
  color: gray;
  font-size: 9px;
  width: 56px;
  height: 12px;
  user-select: none !important;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
  cursor: pointer;
}

.scroller {
  height: 100%;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
